import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RegionState } from './types';
import { RootState } from '../types';

export const state: RegionState = {
  region: undefined,
  dataRegion: [],
};

const namespaced: boolean = true;

export const region: Module<RegionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
